export namespace User {
	export enum TIPO_ACESSO {
		GERENCIA_ADMINISTRATIVA,
		GERENCIA_COMERCIAL,
		CONSULTOR,
		USUARIO_MASTER,
		USUARIO_GERENTE,
		USUARIO_BASICO
	}

	export interface IUser {
		accessToken: string | null
		refreshToken: string | null
		id: string | null
		franquiaId: number | null
		name: string | null
		email: string | null
		parceiroId: string | null
		tipoAcesso: number | null
		isLead: boolean | null
		client_id: string
		grupo: number
		role: number | null
		franquiaUsuarioIsExpert: boolean
		isAnalista: boolean
		rules: Array<string>
		lastIsolveChangelogSeen: string | null

		IsGerenciaAdministrativa(): boolean

		IsGerenciaComercial(): boolean

		IsConsultor(): boolean

		IsUsuarioMaster(): boolean

		IsUsuarioGerente(): boolean

		IsUsuarioBasico(): boolean

		IsAnalista(): boolean
		IsFranquiaExpert(): boolean
	}

	export class User implements IUser {
		accessToken: string | null
		id: string | null
		franquiaId: number | null
		name: string | null
		email: string | null
		parceiroId: string | null
		tipoAcesso: number | null
		isLead: boolean | null
		client_id: string
		grupo: number
		role: number | null
		franquiaUsuarioIsExpert: boolean = false
		isAnalista: boolean = false
		rules: string[]
		lastIsolveChangelogSeen: string | null = null

		constructor(user: any) {
			const { access_token, refresh_token, profile, client_id } = user
			const { name, email, tipoacesso, sub, parceiroid, franquiaid, franquiausuarioisexpert, grupo, isanalita, lastchangelogseen } = profile
				? profile
				: user

			this.accessToken = access_token
			this.refreshToken = refresh_token
			this.id = sub
			this.franquiaId = franquiaid
			this.name = name
			this.email = email
			this.parceiroId = parceiroid
			this.tipoAcesso = tipoacesso || 0 // Default to 0 for backward compatibility
			this.isLead = typeof sub === 'string' && sub.indexOf('-') > -1
			this.client_id = client_id
			this.grupo = grupo || 0 // Default to 0 for backward compatibility
			this.role = tipoacesso || 0 // Default to 0 for backward compatibility
			this.franquiaUsuarioIsExpert = franquiausuarioisexpert == 'True'
			this.isAnalista = isanalita === true || isanalita === 'True'
			this.rules = new Array<string>()
			this.lastIsolveChangelogSeen = lastchangelogseen
		}
		refreshToken: string | null

		public IsGerenciaAdministrativa = () => this.role != null && this.role <= 3

		public IsGerenciaComercial = () => this.role != null && this.role <= 4

		public IsConsultor = () => this.role != null && this.role <= 5

		public IsUsuarioMaster = () => this.role != null && this.role == 7

		public IsUsuarioGerente = () => this.role != null && this.role == 8

		public IsUsuarioBasico = () => this.role != null && this.role == 9
		public IsAnalista = () => this.isAnalista
		public IsFranquiaExpert = () => this.franquiaUsuarioIsExpert
	}

	export interface IUserDetails {
		id: number
		hashId: string
		nome: string
		sobrenome: string
		cpf: string
		dataNascimento: string
		telefoneCelularDdd: string
		telefoneCelularNumero: string
		email: string
		idFranquia: number
		idParceiro: number
		dataLiberacaoSistema: string
		idUsuarioAdmLiberacao: number
		dataCadastro: string
		dataUltimoLogin: string
		status: boolean
		pathAvatar: string
		desativacaoMotivo: string
		desativacaoObservacao: string
	}

	export class UserDetails implements IUserDetails {
		id: number = 0
		hashId: string = ''
		nome: string = ''
		sobrenome: string = ''
		cpf: string = ''
		dataNascimento: string = ''
		telefoneCelularDdd: string = ''
		telefoneCelularNumero: string = ''
		email: string = ''
		idFranquia: number = 0
		idParceiro: number = 0
		dataLiberacaoSistema: string = ''
		idUsuarioAdmLiberacao: number = 0
		dataCadastro: string = ''
		dataUltimoLogin: string = ''
		status: boolean = false
		pathAvatar: string = ''
		desativacaoMotivo: string = ''
		desativacaoObservacao: string = ''
	}

	export interface IUserAvatar {
		circleColor: string
		accessoriesType: string
		clotheType: string
		clotheColor: string
		eyebrowType: string
		eyeType: string
		facialHairColor: string
		facialHairType: string
		graphicType: string
		hairColor: string
		mouthType: string
		skinColor: string
		topType: string
		topColor: string
	}

	export class UserAvatar implements IUserAvatar {
		circleColor: string = 'rgb(245, 245, 245)'
		accessoriesType: string = ''
		clotheType: string = ''
		clotheColor: string = ''
		eyebrowType: string = ''
		eyeType: string = ''
		facialHairColor: string = ''
		facialHairType: string = ''
		graphicType: string = ''
		hairColor: string = ''
		mouthType: string = ''
		skinColor: string = 'Light'
		topType: string = ''
		topColor: string = ''
	}

	export interface IUserPhoneUpdate {
		mobilePhoneDdd: number
		mobilePhoneNumber: string
	}

	export class UserPhoneUpdate implements IUserPhoneUpdate {
		mobilePhoneDdd: number = 0
		mobilePhoneNumber: string = ''
	}

	export interface IUserAccount {
		userId: number
		fullName: string
		email: string
		franchiseName: string
		franchiseId: number
		partnerId: number
		isExpertFranchise: boolean
		isAnalyst: boolean
	}
}
